import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Card, Badge, fmtDate } from "./ui";
import { Star, Check, X, Trash2, Award } from "lucide-react";
import { toast } from "sonner";

export default function AdminReviews() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = () => api.get("/admin/reviews").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upd = async (id, body, msg) => { try { await api.patch(`/admin/reviews/${id}`, body); toast.success(msg); load(); } catch (e) { toast.error(apiErr(e)); } };
  const del = async (id) => { if (!window.confirm("Review verwijderen?")) return; try { await api.delete(`/admin/reviews/${id}`); toast.success("Verwijderd"); load(); } catch (e) { toast.error(apiErr(e)); } };

  const shown = rows.filter((r) => filter === "all" || r.status === filter);

  return (
    <div>
      <PageHeader title="Reviews" subtitle="Modereer klantreviews voordat ze live gaan">
        <select value={filter} onChange={(e) => setFilter(e.target.value)} className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-2.5 text-sm text-white focus:outline-none">
          {["all", "pending", "approved", "rejected", "archived"].map((s) => <option key={s} value={s}>{s === "all" ? "Alle" : s}</option>)}
        </select>
      </PageHeader>

      <div className="grid gap-4 md:grid-cols-2">
        {shown.map((r) => (
          <Card key={r.id} className="p-5" data-testid={`admin-review-${r.id}`}>
            <div className="flex items-center justify-between">
              <div className="flex gap-1">{[1,2,3,4,5].map((n) => <Star key={n} size={15} className={n <= r.rating ? "fill-sfc-yellow text-sfc-yellow" : "text-white/20"} />)}</div>
              <div className="flex items-center gap-2">{r.is_featured && <Award size={15} className="text-sfc-orange" />}<Badge status={r.status} /></div>
            </div>
            <p className="mt-3 text-sm text-white/80">“{r.text}”</p>
            <p className="mt-3 text-xs text-white/50">{r.name}{r.company_name ? ` · ${r.company_name}` : ""} · {fmtDate(r.created_at)}</p>
            <div className="mt-4 flex flex-wrap gap-2">
              <button data-testid={`approve-review-${r.id}`} onClick={() => upd(r.id, { status: "approved" }, "Goedgekeurd")} className="flex items-center gap-1 rounded-full bg-emerald-500/15 px-3 py-1.5 text-xs text-emerald-300 hover:bg-emerald-500/25"><Check size={13} /> Goedkeuren</button>
              <button onClick={() => upd(r.id, { status: "rejected" }, "Afgewezen")} className="flex items-center gap-1 rounded-full bg-red-500/15 px-3 py-1.5 text-xs text-red-300 hover:bg-red-500/25"><X size={13} /> Afwijzen</button>
              <button onClick={() => upd(r.id, { is_featured: !r.is_featured }, "Bijgewerkt")} className="flex items-center gap-1 rounded-full border border-white/15 px-3 py-1.5 text-xs text-white/80 hover:bg-white/10"><Award size={13} /> {r.is_featured ? "Niet uitlichten" : "Uitlichten"}</button>
              <button onClick={() => del(r.id)} className="flex items-center gap-1 rounded-full border border-red-500/20 px-3 py-1.5 text-xs text-red-300 hover:bg-red-500/10"><Trash2 size={13} /></button>
            </div>
          </Card>
        ))}
      </div>
      {shown.length === 0 && <p className="mt-10 text-white/40">Geen reviews</p>}
    </div>
  );
}
